import React from 'react';


const CookiesPolicy = () => (
  <div className="content">
    <div className="container">
      <h1 className="h3">Cookie Policy</h1>
      <div className="well">
        <p className="h4">
          How we manage cookies on our Website
        </p>
        <p>
          We use cookies and similar tools on our Website
          to improve its performance and enhance your user
          experience. This policy explains how we do that.
        </p>
        <p className="h4">What are cookies?</p>
        <p>
          Cookies are small text files which a website may
          put on your computer or mobile device when you
          first visit a site or page. The cookie will help
          the website, or another website, to recognize
          your device the next time you visit. Web beacons
          or other similar files can also do the same
          thing. We use the term "cookies" in this policy
          to refer to all files that collect information
          in this way.
        </p>
        <p>
          There are many functions cookies serve. For
          example, they can help us to remember your
          username and preferences, analyze how well our
          website is performing, or even allow us to
          recommend content we believe will be most
          relevant to you.
        </p>
        <p>
          Certain cookies contain personal information –
          for example, if you click to "remember me" when
          logging in, a cookie will store your username.
          Most cookies won't collect information that
          identifies you, and will instead collect more
          general information such as how users arrive at
          and use our websites, or a user's general
          location.
        </p>
        <p className="h4">
          What sort of cookies do we use?
        </p>
        <p>
          We use both session cookies (which expire once
          you close your web browser) and persistent
          cookies (which stay on your device for a set
          period of time or until you delete them).
        </p>
        <p>
          Generally, our cookies perform four primary
          functions:
        </p>
        <p className="h5">Essential cookies</p>
        <p>
          Some cookies are essential for the operation of
          our Website. For example, some cookies allow us
          to identify subscribers and ensure they can
          access the subscription-only pages. If a
          subscriber opts to disable these cookies, the
          user may not be able to access all of the
          content that a subscription entitles them to.
        </p>
        <p className="h5">Performance cookies</p>
        <p>
          We utilize other cookies to analyze how our
          visitors use our Website and to monitor Website
          performance. This allows us to provide a high
          quality experience by customizing our offering
          and quickly identifying and fixing any issues
          that arise. For example, we might use
          performance cookies to keep track of which pages
          are most popular, which method of linking
          between pages is most effective, and to
          determine why some pages are receiving error
          messages. We might also use these cookies to
          highlight pages or site services that we think
          will be of interest to you based on your usage
          of the website.
        </p>
        <p className="h5">Functionality cookies</p>
        <p>
          We use functionality cookies to allow us to
          remember your preferences. For example, cookies
          save you the trouble of typing in your username
          every time you access our Website.
        </p>
        <p>
          We also use functionality cookies to provide you
          with enhanced services such as allowing you to
          watch a video online or comment on a blog.
        </p>
        <p className="h5">
          Behaviorally targeted advertising cookies
        </p>
        <p>
          We and our advertisers use cookies to serve you
          with advertisements that we believe are relevant
          to you and your interests. You might see these
          advertisements on our Website and on other sites
          that you visit. However, we do not tell our
          advertisers who you are. These cookies record
          your visit to our Website, the pages you have
          visited and the links you have followed. We will
          use this information to make our Website and the
          advertising displayed on it more relevant to
          your interests. We may also share this
          information with third parties for this purpose.
          Without these cookies, online advertisements you
          encounter will be less relevant to you and your
          interests.
        </p>
        <p className="strong">
          You can find more information about the
          individual first-party cookies we use and the
          purposes for which we use them in the table
          below:
        </p>
        <table className="table table-condensed table-striped">
          <thead>
            <tr>
              <th>Name</th>
              <th>Purpose</th>
              <th>Expiration</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>_atc</td>
              <td>Tracks affiliate traffic</td>
              <td>30 days</td>
            </tr>
            <tr>
              <td>_atcd</td>
              <td>
                Assists _atc cookie to speed up
                subsequent requests
              </td>
              <td>30 days</td>
            </tr>
            <tr>
              <td>_invalid_logins</td>
              <td>
                Helps a user if they ve been unable
                to login with further instruction
              </td>
              <td>20 minutes</td>
            </tr>
            <tr>
              <td>_skpubc</td>
              <td>
                Flag to determine if a Premium
                Upgrade Bar has been closed
              </td>
              <td>1 month</td>
            </tr>
            <tr>
              <td>_skpubs</td>
              <td>
                Flag to determine if Premium Upgrade
                Bar has been moved to a static state
              </td>
              <td>1 month</td>
            </tr>
            <tr>
              <td>_mskautoplay</td>
              <td>
                Flag to determine user preference on
                auto-playing media
              </td>
              <td>30 days</td>
            </tr>
            <tr>
              <td>_skvolume</td>
              <td>
                Last known volume level for Media
                Player
              </td>
              <td>30 days</td>
            </tr>
            <tr>
              <td>_mskMediaInfoState</td>
              <td>
                Flag to determine Media Display
                preferences on Media Filter
              </td>
              <td>30 days</td>
            </tr>
            <tr>
              <td>_skvquality</td>
              <td>
                Preference to the quality selected
                for media
              </td>
              <td>30 days</td>
            </tr>
            <tr>
              <td>_skvsquality</td>
              <td>
                Last known quality to be viewed with
                media by the user
              </td>
              <td>30 days</td>
            </tr>
            <tr>
              <td>_membership</td>
              <td>
                Helps users who have previously been
                a member
              </td>
              <td>2 months</td>
            </tr>
            <tr>
              <td>_authenticated</td>
              <td>
                Helps users who have previously been
                a logged into website
              </td>
              <td>2 months</td>
            </tr>
            <tr>
              <td>_sktrk</td>
              <td>
                Enable or Disable the use of
                Analytics Platform(s)
              </td>
              <td>5 years</td>
            </tr>
            <tr>
              <td>notify_*</td>
              <td>
                Set to remember if a user has seen
                specific notifications
              </td>
              <td>14 days</td>
            </tr>
            <tr>
              <td>st*</td>
              <td>
                Stores User Experience Split test
                tracking state
              </td>
              <td>60 days</td>
            </tr>
            <tr>
              <td>_nnsess</td>
              <td>
                Allows a user to login to account
              </td>
              <td>Maximum: 1 year</td>
            </tr>
          </tbody>
        </table>
        <p className="h4">
          Does anyone else use cookies on our Website?
        </p>
        <p>
          Advertisers sometimes use their own cookies to
          provide you with targeted advertising. For
          example, advertisers may use a profile they have
          built on sites that you have previously visited
          to present you with more relevant advertisements
          during your visit to our websites. We believe
          that it is useful to our users to see
          advertisements that are more relevant to their
          interests. If you are based in the European
          Union and would like to learn more about how
          advertisers use these types of cookies or to
          choose not to receive them, please visit
          www.youronlinechoices.eu. If you are based in
          the United States and would like to learn more,
          please visit http://www.aboutads.info/choices/.
        </p>
        <p>
          We also use or allow third parties to serve
          cookies that fall into the four categories
          above. For example, like many companies, we use
          Google Analytics to help us monitor our Website
          traffic. We may also enable third parties to
          serve cookies to help to identify fraudulent or
          non-human traffic on our Website. We may also
          use third-party cookies to help us with market
          research, revenue tracking, improving site
          functionality and monitoring compliance with our
          terms and conditions and copyright policy.
        </p>
        <p className="h4">
          Can a website user block cookies?
        </p>
        <p>
          As we ve explained above, cookies help you to
          get the most out of our Website. If you do wish
          to disable our cookies then please follow the
          instructions in our{' '}
          <a href="/cookie-settings">
            How to Manage Cookies
          </a>{' '}
          section. Please remember that if you choose to
          disable cookies, you may find that certain
          sections of our Website do not work properly.
        </p>
        <p>
          You can opt out of all behaviorally targeted
          advertising cookies on our Website by going
          to&nbsp;
          <a
            href="https://www.google.com/settings/ads"
            rel="noopener noreferrer"
            target="_blank"
          >
            https://www.google.com/settings/ads
          </a>
          . By opting out of this type of cookie, you will
          stop receiving ads that are targeted
          specifically to you on these sites; however you
          will still receive generic advertising.
        </p>
        <p className="h4">
          Do we track whether users open our emails?
        </p>
        <p>
          Our emails may contain a single, campaign-unique
          "web beacon pixel" to tell us whether, and how
          many times, our emails are opened and verify any
          clicks through to links or advertisements within
          the email. We may use this information for
          purposes including determining which of our
          emails are more interesting to users, to query
          whether users who do not open our emails wish to
          continue receiving them, to check that content
          is being used in accordance with our terms and
          conditions, and to inform our advertisers in
          aggregate how many users have clicked on their
          advertisements. The pixel will be deleted when
          you delete the email. If you do not wish the
          pixel to be downloaded to your device, you
          should select to receive emails from us in plain
          text rather than HTML.
        </p>
        <p className="h4">Other tracking technologies</p>
        <p>
          We may also use mobile device identifiers and
          the other technologies identified in{' '}
          <a href="/privacy_policy#s6">
            Section 6 of our Privacy Policy
          </a>{' '}
          for the purposes articulated in our{' '}
          <a href="/privacy_policy">Privacy Policy</a>,
          for example to recognize your device when you
          use our Service.
        </p>
      </div>
    </div>
  </div>
);

export default CookiesPolicy;
